/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { analyticsService } from 'analytics';
import * as angular from 'angular';

import { fbReporting } from 'src/app/plain-javascript/background-scripts/fb-reporting';
declare const Intercom: any;

class IntercomHandler {
	constructor($timeout: any, popup: any) {
		this.$timeout = $timeout;
		this.popup = popup;
		analyticsService.ready(() => {
			this.onReady();
		});
	}
	public static $inject = ['$timeout', 'popup'];
	private $timeout: any;
	private isReady = false;
	private popup: any;
	public isShown = false;
	public notificationCount = 0;
	public onReady() {
		this.isReady = true;
		this.loadIntercom();
	}
	public loadIntercom() {
		Intercom('onShow', () => {
			this.onShow();
		});
		Intercom('onHide', () => {
			this.onHide();
		});
		Intercom('onUnreadCountChange', (count: number) => {
			this.onUnreadCountChange(count);
		});
	}
	public show() {
		if (!this.isReady) {
			this.displayError();
			return;
		}
		this.isShown = true;
		Intercom('show');
	}
	public hide() {
		if (!this.isReady) {
			this.displayError();
			return;
		}
		this.isShown = false;
		Intercom('hide');
	}
	public toggle() {
		if (!this.isReady) {
			this.displayError();
			return;
		}
		this.isShown = !this.isShown;
		if (this.isShown) {
			Intercom('show');
		} else {
			Intercom('hide');
		}
	}
	private displayError() {
		fbReporting.reportRealWarning('Intercom blocked by ad blocker, probably.');
		this.popup({
			title: 'Could not connect to support',
			description:
				'Something is blocking connection to live support. Please email us at support@touchplan.io',
			template: require('html-loader?root=src/!tpl/popups/simple.html'),
		});
	}
	private onShow() {
		this.$timeout(() => {
			this.isShown = true;
		});
	}
	private onHide() {
		this.$timeout(() => {
			this.isShown = false;
		});
	}
	private onUnreadCountChange(count: number) {
		this.$timeout(() => {
			this.notificationCount = count;
		});
	}
}

angular.module('ticketspaceApp').service('intercomHandler', IntercomHandler);
